/**
 * What a page shows while its {@link PollController} has nothing to show yet: a placeholder while
 * loading, the reason when the load failed. Returns null once there is a value, so a page reads:
 *
 *     const pending = loadState(this.poll);
 *     if (pending) return pending;
 */
import { html } from 'lit';

export function loadState(poll, what = 'this page') {
  if (poll.value !== undefined) {
    return null;
  }
  if (poll.error) {
    const error = poll.error;
    if (error.status === 403) {
      return html`<div class="notice" data-tone="muted" role="alert"><strong>Operators only</strong>Your account can see the workspaces of your customers, not ${what}.</div>`;
    }
    const notFound = error.status === 404;
    return html`
      <div class="notice" data-tone=${notFound ? 'muted' : 'danger'} role="alert">
        <strong>${notFound ? 'Not found' : `Could not load ${what}`}</strong>
        ${notFound ? error.message : html`${error.message} <button class="small" @click=${() => poll.refresh()}>Retry</button>`}
      </div>
    `;
  }
  return html`<p class="muted" aria-busy="true">Loading…</p>`;
}

/** The error of a reload that failed while the page still shows the previous value. */
export function staleWarning(poll) {
  if (poll.value === undefined || !poll.error) {
    return null;
  }
  return html`<div class="notice" data-tone="warning" role="status">
    <strong>Not up to date</strong>The last refresh failed (${poll.error.message}): what you see may be old.
  </div>`;
}
